<template>
  <div class="general-tooltip" ref="generalTooltip" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <div v-if="show" class="tooltip-content">
      {{ content }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'generalTooltip',
    props: {
      content: {
        type: String
      },
    },
    data() {
      return {
        show: false,
      }
    },
    methods: {
      showTooltip() {
        this.show = true;
        this.$emit('show-tooltip', true);
    },
     hideTooltip() {
        this.show = false;
        this.$emit('show-tooltip', false);
      },
    }
  }
</script>

<style scoped lang="scss">
  .general-tooltip{
    display: inline-flex;
    height: 20px;
    align-items: center;
    margin-left: 1%;
    z-index: 3;
    position: relative;

    .tooltip-content {
      position: absolute;
      top: 100%;
      width: 281px;
      max-width: 298px;
      transform: translateX(-50%);
      color: #fff;
      font-size: 12px;
      background: #3A424E;
      border-radius: 5px;
      padding: 3px 10px;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      z-index: 999999;
    }
  }
</style>


// WEBPACK FOOTER //
// src/vue/views/components/generalTooltip.vue